import { createBrowserRouter, Navigate, type RouteObject } from 'react-router';
import { resolveHost } from '@/utils/hosts';
import { EmptyState } from '@/components';
import AuthLayout from '@/layouts/AuthLayout';

// Cada módulo declara as próprias rotas em modules/<Modulo>/routes.tsx
import authRoutes from '@/modules/Auth/routes';
import registrationRoutes from '@/modules/PatientRegistration/routes';
import patientRoutes from '@/modules/PatientArea/routes';
import cabinRoutes from '@/modules/Cabin/routes';
import doctorPublicRoutes from '@/modules/DoctorPublicPage/routes';
import doctorRoutes from '@/modules/DoctorArea/routes';
import documentRoutes from '@/modules/ClinicalDocuments/routes';
import franchiseeRoutes from '@/modules/Franchisee/routes';
import financeRoutes from '@/modules/Finance/routes';
import managerRoutes from '@/modules/Manager/routes';
import supportRoutes from '@/modules/Support/routes';
import patientHistoryRoutes from '@/modules/PatientHistory/routes';
import patientDisputeRoutes from '@/modules/PatientDisputes/routes';
import patientAppointmentRoutes from '@/modules/PatientAppointments/routes';
import doctorFinanceRoutes from '@/modules/DoctorFinance/routes';
import onDutyRoomRoutes from '@/modules/OnDutyRoom/routes';
import docsRoutes from '@/modules/Docs/routes';

const common: RouteObject[] = [
  { path: '/sem-permissao', element: <AuthLayout><EmptyState icon="🔒" title="Você não tem acesso a esta área."><a href="/">Voltar ao início</a></EmptyState></AuthLayout> },
  { path: '*', element: <AuthLayout><EmptyState icon="🧭" title="Página não encontrada."><a href="/">Voltar ao início</a></EmptyState></AuthLayout> },
];

/**
 * Subdomínios decididos no handoff: {codigo}.azanas.tech abre o totem; {medico}.azanas.me abre a página pública.
 * Nos demais endereços (app/painel), todas as rotas ficam disponíveis.
 */
function buildRoutes(): RouteObject[] {
  const host = resolveHost();
  if (host.kind === 'cabin') return [{ path: '/', element: <Navigate to={`/cabine/${host.subdomain}`} replace /> }, ...cabinRoutes, ...common];
  if (host.kind === 'doctor-page') return [{ path: '/', element: <Navigate to={`/m/${host.subdomain}`} replace /> }, ...doctorPublicRoutes, ...authRoutes, ...registrationRoutes, ...patientRoutes, ...patientAppointmentRoutes, ...common];
  return [
    ...docsRoutes,
    ...authRoutes,
    ...registrationRoutes,
    ...patientRoutes,
    ...patientHistoryRoutes,
    ...patientDisputeRoutes,
    ...patientAppointmentRoutes,
    ...cabinRoutes,
    ...doctorPublicRoutes,
    ...doctorRoutes,
    ...doctorFinanceRoutes,
    ...onDutyRoomRoutes,
    ...documentRoutes,
    ...franchiseeRoutes,
    ...financeRoutes,
    ...managerRoutes,
    ...supportRoutes,
    ...common,
  ];
}

export const router = createBrowserRouter(buildRoutes());
